
import React from 'react'
import { useLocation, useNavigate,Link } from 'react-router-dom';
import { Box, ActionMenu, ActionList, Button, Avatar, AnchoredOverlay, IconButton, Text } from '@primer/react'
import { useDispatch, useSelector } from "react-redux";
import { scheduleDemoOpenClose } from '../redux/features/scheduleDemoSlice';
import { searchOpenClose } from "../redux/features/searchSlice"
import workplaceTheme from './Workplacetheme'
import { BellIcon, QuestionMarkCircledIcon, MagnifyingGlassIcon } from '@radix-ui/react-icons'
import ScheduleDemoDialog from './Dialogs/ScheduleDemoDialog';
import { Auth } from 'aws-amplify';
import HeaderSubComponent from './HeaderSubComponent';
import {UnderlineNav} from '@primer/react/drafts'

const logoUrl = "/deski-logo.svg"


function Header() {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()

    const schedulereturnFocusRef = React.useRef(null)
    const [showUnderlineNav,setshowUnderlineNav] = React.useState(false)
    const [showItHeaderNav,setshowItHeaderNav] = React.useState(false)

    const [selectedIndex,setselectedIndex] = React.useState(0)
    const [selectedItHeadIndex,setselectedItHeadIndex] = React.useState(0)
     
 


    return (


        <Box
            position="fixed"
            width={'100%'}
            height={48}
            background="#FFFFFF"
            borderColor="border.default"
            borderWidth={1}
            borderStyle="solid"
            p={0}
            zIndex={10}

        >
            <Box sx={workplaceTheme.headerInnerStyle}>

                <img
                    style={workplaceTheme.logoStyle}
                    src={logoUrl}
                    onClick={() => { navigate('/workplace') }}
                />


                <Box
                   
                     style={{
                           display:
                           location.pathname==="/notice"||
                           location.pathname==="/gst"||
                           location.pathname==="/demand"||
                           location.pathname==="/additionalnotice"||
                           location.pathname==="/return"||
                           location.pathname==="/refund"||
                           location.pathname==="/ledger"||
                           location.pathname==="/challan"

                           ?"flex":"none"
                     }}
                     sx={{
                        width: '650px',
                        minWidth: '650px',
                        height: 48,
                        minHeight: 48,
                        position: 'absolute',
                        left:'314px',
                        margin: 'auto',
                        top: 0,
                        bottom: 0,
                        fontFamily: 'Avenir LT Std',
                        fontStyle: 'normal',
                        fontWeight: '400',
                        fontSize: '14px',
                        color: '#121212',
                        
                    }}>
                    
                </Box>


                <HeaderSubComponent />



            </Box>


            <ScheduleDemoDialog returnFocusRef={schedulereturnFocusRef} />


        </Box>

    )


}

export default Header
